import React from "react";
import { Box } from "@mui/material";

// Template39: Página de Actividades y experiencias en Kioto
// Copia DIRECTA del componente ActivitiesKyoto.jsx de guia-kioto, adaptado para usar las props del sistema guia
const Template185 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const isSmallScreen = window.innerWidth <= 600;

	// Datos hardcodeados directamente en el componente
	const headerText = "Actividades y experiencias en Kioto";
	const actividadesSticker = "/images/kyoto/ceremonia-te.png";

	// Lógica especial para la guía de Tokio: header #24221a en primera página, #e24217 en las siguientes
	const pageOrder = page.order !== undefined ? page.order : (page.data?.order !== undefined ? page.data.order : -1);
	const isTokioGuide = headerBackgroundColor === "#24221a";
	const actualHeaderColor = isTokioGuide && pageOrder > 0 ? "#e24217" : (headerBackgroundColor || "#5ba374");

	// Actividades
	const actividades = [
		{
			icono: "🍵",
			titulo: "Ceremonia del té tradicional",
			texto: "Conoce el ritual japonés del té en un salón de té de Kioto.",
			link: "https://gyg.me/gfjwz1vM",
		},
		{
			icono: "👘",
			titulo: "Alquiler de kimono y paseo por Gion",
			texto: "Vístete con un kimono tradicional y pasea por las calles de Gion o el templo Kiyomizudera.",
			link: "https://gyg.me/tqBiieL6",
		},
		{
			icono: "🍱",
			titulo: "Clase de cocina japonesa",
			texto: "Aprende a preparar sushi con un chef local.",
			link: "https://gyg.me/RlNK8Lrp",
		},
		{
			icono: "🌙",
			titulo: "Tour nocturno por Gion",
			texto: "Descubre el barrio de Gion al anochecer y aprende sobre el mundo de las maikos y geikos.",
			link: "https://gyg.me/28CsKBb1",
		},
		{
			icono: "🦌",
			titulo: "Excursión a Nara y Fushimi Inari",
			texto: "Visita lugares emblemáticos de Japón en un solo día: los torii rojos de Fushimi Inari y la ciudad de Nara.",
			link: "https://gyg.me/Hm9HjSUw",
		},
		{
			icono: "🍶",
			titulo: "Tour por bares izakaya en Kioto",
			texto: "Vive una experiencia local en los tradicionales bares izakaya de Kioto.",
			link: "https://gyg.me/9AIp5RtV",
		},
	];

	// Textos
	const introText = "Desde ceremonias del té hasta tours con guía local o clases de cocina, aquí tienes algunas de las actividades más recomendadas.";

	// Estilos
	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: 8,
		margin: 0,
		padding: 0,
		color: "#3d805e",
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: 13,
		color: "#444",
		margin: 0,
		lineHeight: 1.5,
	};

	const box = {
		backgroundColor: "#d9e6de",
		border: "3px solid #5ba374",
		borderRadius: "16px",
		padding: "14px 16px",
	};

	const link = {
		color: "#5ba374",
		textDecoration: "underline",
		fontWeight: 600,
		display: "inline-block",
		fontSize: 12,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
			height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "10px !important",
				},
			}}
		>
			{/* CABECERA */}
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 800,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1053,
				}}
			>
				{headerText}
			</Box>

			{/* INTRO */}
			<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: "13px", color: "#444" }}>
				<Box component="p" sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}>
					{introText}
				</Box>
			</Box>

			{/* BLOQUES DE ACTIVIDADES */}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "14px",
				}}
			>
				{actividades.map((actividad, index) => (
					<Box
						key={index}
						data-block-id={`text-${index + 3}`}
						sx={{
							...box,
							position: index === actividades.length - 1 ? "relative" : "static",
						}}
					>
						<Box component="h3" sx={{ ...h3, width: index === actividades.length - 1 ? (isSmallScreen ? "80%" : "90%") : "100%" }}>
							{actividad.icono} {actividad.titulo}
						</Box>
						<Box component="p" sx={{ ...p, width: index === actividades.length - 1 ? (isSmallScreen ? "70%" : "85%") : "100%", margin: "0 !important", marginBottom: "0px !important" }}>
							{actividad.texto}{" "}
							<Box
								component="a"
								href={actividad.link}
								target="_blank"
								rel="noreferrer"
								sx={link}
							>
								Reservar aquí
							</Box>
						</Box>
						{index === actividades.length - 1 && (
							<Box
								component="img"
								src={actividadesSticker}
								alt="Actividades Sticker"
								sx={{
									width: 110,
									position: "absolute",
									bottom: isSmallScreen ? "-20px" : "20px",
									right: isSmallScreen ? "-20px" : "-30px",
								}}
							/>
						)}
					</Box>
				))}
			</Box>
		</Box>
	);
};

Template185.thumbnail = "/images/template-1.png";

export default Template185;

